import '../Register/Register.scss';
import { FaFacebook, FaTwitter } from "react-icons/fa6";
import { FaGoogle } from "react-icons/fa";
import React from 'react';
import { useFormik } from 'formik';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify';

const AdminLogin = () => {

    const navigate = useNavigate();

    const formik = useFormik({
        initialValues: {
            admin_info: "", // For The Email Or Mobile No.
            admin_pass: "", // For The Password
            admin_conf_pass: "" // for The Confirm Password
        },

        validate: (values) => {
            const errors = {};
            const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i; // Regex for email
            const mobileRegex = /^[6-9]\d{9}$/; // Regex for mobile number (must start with 6-9 and 10 digits)

            // Validate admin_info (either email or mobile number)
            if (!values.admin_info) {
                errors.admin_info = "Please provide an email or mobile number.";
            } else {
                // Check if the admin_info is a valid email or a valid mobile number
                if (emailRegex.test(values.admin_info)) {
                } else if (mobileRegex.test(values.admin_info)) {
                } else {
                    errors.admin_info = "Invalid email or mobile number format.";
                }
            }

            // Password validation
            if (!values.admin_pass) {
                errors.admin_pass = "Please Enter Password";
            } else if (values.admin_pass.length < 8) {
                errors.admin_pass = "Password should be at least 8 characters long";
            } else if (!/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*]).{8,}$/.test(values.admin_pass)) {
                errors.admin_pass = "Password should contain at least one uppercase letter, one lowercase letter, one digit, and one special character (!@#$%^&*)";
            }

            if (!values.admin_conf_pass) {
                errors.admin_conf_pass = "Please confirm your password";
            } else if (values.admin_conf_pass !== values.admin_pass) {
                errors.admin_conf_pass = "Passwords do not match";
            }

            return errors;
        },

        onSubmit: async (values) => {
            try {
                console.log('Submitted Data:', values);  // Log submitted data

                const response = await axios.post('https://ridehire-backend-2.onrender.com/admin/login', values, {
                    headers: {
                        'Content-Type': 'application/json',
                    }
                });

                console.log('Full Response:', response);
                console.log('API Response Data:', response.data); // Log response data

                if (!response.data) {
                    console.error("Empty response from server.");
                    toast.error("Server error. Please try again later.");
                    return;
                }

                // Extract token and data
                const { token, data } = response.data;
                console.log('Extracted Token:', token);
                console.log('Extracted data:', data);

                if (!token || !data) {
                    console.warn("Login failed. Missing token or data data.");
                    toast.error("Login failed. Please check your credentials.");
                    return;
                }

                // Store token & data in localStorage
                localStorage.setItem('tokenAdmin', token);
                localStorage.setItem('dataAdmin', JSON.stringify(data));

                console.log('Stored Token:', token);
                console.log('Stored data:', data);

                navigate('/admin/AdminDashboard');
                toast.success("Login successful");

            } catch (error) {
                console.error('Login Error:', error);

                if (error.response) {
                    console.error('Error Response:', error.response.data);

                    if (error.response.status === 401) {
                        toast.error("Invalid email or password. Please try again.");
                    } else {
                        toast.error(error.response.data.message || "Login failed. Please try again.");
                    }
                } else {
                    toast.error("Network error. Please check your connection.");
                }
            }
        }
    })

    const GoogleLoginButton = () => {
        const handleLogin = () => {
            window.location.href = "https://ridehire-backend-2.onrender.com/admin/auth/google";
        };
    
        return <FaGoogle onClick={handleLogin} className="icon ms-4 fs-3" />;
        
    };
    const FacebookLogin = () =>{
        const FACEBOOK_AUTH_URL = `https://www.facebook.com/v15.0/dialog/oauth?client_id=1177972973955105&redirect_uri=https://ridehire-backend-2.onrender.com/admin/auth/facebook/callback&scope=email,public_profile`;
        const handleLogin = () => {
            window.location.href = FACEBOOK_AUTH_URL;
          
        };
        return <FaFacebook onClick={handleLogin} className="icon fs-3" />
    }

    return (
        <>
            <div className="banner  mt-5">
                <div className="row signin m-0">
                    <div className="text-white mt-5 ps-5">
                        <a href='/admin/home' className='text-white text-decoration-none'><h6 className=''>Home &nbsp; / &nbsp; Login </h6></a>
                        <h3 className="text-white">admin Login</h3>
                    </div>
                </div>

                <div className="container register-form mb-5">
                    <div className="row justify-content-center">
                        <div className="box row p-3 mt-5 border border-secondary-subtle rounded">
                            <div className="d-flex justify-content-center">
                                <h2>Login Here</h2>
                            </div>

                            <form method="post" onSubmit={formik.handleSubmit}>
                                <div className="row mt-4 my-4">
                                    <div className="col-md-12 col-12 mt-3">
                                        <label>Email or Mobile Number </label>
                                        <input
                                            type="text"
                                            name="admin_info"
                                            value={formik.values.admin_info}
                                            onChange={formik.handleChange}
                                            className="w-100 form-control shadow-none mt-2"
                                            placeholder="Email or Mobile No"
                                        />
                                        {formik.touched.admin_info && formik.errors.admin_info ? (
                                            <p className="text-danger">{formik.errors.admin_info}</p>
                                        ) : null}
                                    </div>

                                    <div className="col-md-12 col-12 mt-3">
                                        <label>Password </label>
                                        <input
                                            type="password"
                                            name="admin_pass"
                                            value={formik.values.admin_pass}
                                            onChange={formik.handleChange}
                                            className="w-100 form-control shadow-none mt-2"
                                            placeholder="Password"
                                        />
                                          {formik.touched.admin_pass && formik.errors.admin_pass ? (
                                            <p className="text-danger">{formik.errors.admin_pass}</p>
                                        ) : null}
                                    </div>

                                    <div className="col-md-12 col-12 mt-3">
                                        <label>Confirm Password </label>
                                        <input
                                            type="password"
                                            name="admin_conf_pass"
                                            value={formik.values.admin_conf_pass}
                                            onChange={formik.handleChange}
                                            className="w-100 form-control shadow-none mt-2"
                                            placeholder="Re-Enter Password"
                                        />
                                         {formik.touched.admin_conf_pass && formik.errors.admin_conf_pass ? (
                                            <p className="text-danger">{formik.errors.admin_conf_pass}</p>
                                        ) : null}
                                    </div>

                                    <div className="remember-forgot d-flex justify-content-between align-items-center mt-4">
                                        <div className="remember-me">
                                            <input className="form-check-input" type="checkbox" value="" id="invalidCheck" required />
                                            <label className="form-check-label ms-3" htmlFor="invalidCheck">
                                                Agree to terms and conditions
                                            </label>
                                        </div>
                                        <Link to={'/forgotPassword'} className="forgot-password font-weight-bold text-black text-decoration-none">Forgot password?</Link>
                                    </div>

                                    <div className="d-flex justify-content-center">
                                        <button
                                            type="submit"
                                            className="submit-btn w-25 mt-4 text-white rounded py-2"
                                        >
                                            Login
                                        </button>
                                    </div>

                                    <div className="divider d-flex align-items-center my-4 py-0">
                                        <span className='fs-6 px-4'>Or Continue With</span>
                                    </div>

                                    <div className="form-social d-inline-flex justify-content-center">
                                        <div>
                                            <FacebookLogin/>
                                            <GoogleLoginButton/>
                                            <FaTwitter className="icon ms-4 fs-3" />
                                        </div>
                                    </div>
                                    <div className="signup-link d-inline-flex justify-content-center mt-3">
                                        <p>Don't have an account? <a href="/admin/register" className='font-weight-bold text-black text-decoration-none'>Sign up</a></p>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default AdminLogin;
